// src/layouts/WebsiteLayout.tsx
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ModalBackdropCleanup from "../../components/shared/ModalBackdropCleanup";
import PageLoader from "../../components/shared/PageLoader";

const WebsiteLayout: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className='website-shell'>
      <ModalBackdropCleanup />
      <PageLoader variant='website' />
      <Header />
      <main className='main website-main'>
        <div key={pathname} className='route-transition-shell'>
          <Outlet /> {/* Nested website routes render here */}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default WebsiteLayout;
